import React, { useState, useEffect, useCallback } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import "./Style.css";
// import { useNavigate } from "react-router-dom";
import DynamicGrid from "../../../ReusableComponents/DynamicGrid/DynamicGrid";
import { debounceSearchRender } from "mui-datatables";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import { getAllCalendarEventData } from "../../../helpers/API/APIEndPoints";
import { Tooltip, Typography } from "@mui/material";
import { Redirect } from "react-router";
import { Encrypt } from "../../../helpers/Cryptography/CryptoJS";
import axios from "axios";
import moment from "moment";
import fileDownload from "js-file-download";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory } from "react-router-dom";
import { DATE_TIME_DISPLAY_FORMAT, EXCEL_DATE_TIME_FILENAME_FORMAT } from "../../../helpers/Constants/Constants";
import { OverflowTip } from "../../../ReusableComponents/OverFlowTip/OverflowTip";
import { storeInEncLocalStorage } from "../../../helpers/Utils/Utils";
import { excelDownloadCommon } from "../../../helpers/ExcelDownload/ExcelDownload";

function CalendarEventMaster() {
  let history = useHistory();
  const [Id, setId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [Redirectss, setRedirectss] = useState(false);
  const fileExtension = ".xlsx";

  useEffect(() => {
    (async () => {
      setLoading(true);
      let requestParams = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        isExport: false,
      };

      let res = await APICall(getAllCalendarEventData, requestParams, "POST");
      if (res.message === "Ok") {
        if (res && res.data.length > 0 && res.totalCount > 0) {

          setMasterData(res.data);
          setCount(res.totalCount);
        } else {
          setMasterData([]);
          setCount(0);
        }
      } else {
        setMasterData([]);
        setCount(0);
      }
      setLoading(false);
    })();
  }, [start, sortColumn, sortDirection, searchText, count]);
  const exportToExcelFunction = async () => {
    // showLoader();

    // setLoading(true);
    let requestParams = {
      start: 0,
      resultsPerPage: count,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      isExport: true,
    };
    excelDownloadCommon(getAllCalendarEventData,requestParams,"Calendar-Event-",setLoading)

    // let encryptedParams = await Encrypt(JSON.stringify(requestParams));
    // let reqObj = {
    //   data: encryptedParams,
    // };
    // axios
    //   .request({
    //     method: "POST",
    //     url: getAllCalendarEventData,
    //     data: reqObj,
    //   })
    //   .then((response) => {
    //     let byteArray = new Uint8Array(response.data.data.data);
    //     fileDownload(
    //       byteArray,
    //       `Calendar-Event-` +
    //       `${moment(new Date()).format(EXCEL_DATE_TIME_FILENAME_FORMAT)}${fileExtension}`
    //     ); //add time stamp
    //     setLoading(false);
    //   })
    //   .catch((error) => {
    //     // if (error.response.data.data === null) {
    //     setLoading(false);
    //     notify(1, "Error");
    //     // }
    //   });
    // setLoading(false);
  };

  const gridColumns = [
    {
      name: "Id",
      label: "ID",
      options: {
        display: false,
      },
    },
    {
      name: "activity_title",
      label: "Event Name",

      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "FromDT",

      label: "Event from date ",

      options: {
        setCellHeaderProps: () => ({ style: { maxWidth: '500px' } }),
        customBodyRender: (value, tableMeta) => {
          let dateObj = moment(value);
          let dateStr = dateObj.isValid() ? dateObj.format(DATE_TIME_DISPLAY_FORMAT) : '';
          return (
            <>
              <div style={{ inlineSize: "100px", overflowWrap: "break-word" }}>
                <Typography component={"span"} noWrap={false} variant="" >
                  {dateStr}
                </Typography>
              </div>
            </>
          );
        },

      }
    },
    {
      name: "ToDT",
      label: "Event to date",
      options: {
        customBodyRender: (value, tableMeta) => {
          let dateObj = moment(value);
          let dateStr = dateObj.isValid() ? dateObj.format(DATE_TIME_DISPLAY_FORMAT) : '';
          return (
            <>
              <div style={{ inlineSize: "100px", overflowWrap: "break-word" }}>
                <Typography component={"span"} noWrap={false} variant="" >
                  {dateStr}
                </Typography>
              </div>
            </>
          );
        },
      }
    },
    {
      name: "Location",
      label: "Location",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },

    },
    {
      name: "Venue",
      label: "Venue",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "activity_desc",
      label: "Description",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        setCellProps: () => ({
          style: {
            minWidth: "200px", maxWidth: "300px"
            //   overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box",
            // WebkitBoxOrient: 'vertical',
            // WebkitLineClamp: "1"
          },
          // overflow: "hidden",
          // textOverflow: "ellipsis",
          // display: "-webkit-box",
          // WebkitBoxOrient: 'vertical',
          // WebkitLineClamp: "1"


        }),
        customBodyRender: (value) => {
          return (
            <>
              <OverflowTip>
                <Typography component={"span"} noWrap={false} variant="">
                  {value}

                </Typography>
              </OverflowTip>
            </>
          )
        }


      },
    },
    {
      name: "created_date",
      label: "Created Date",

      options: {
        customBodyRender: (value, tableMeta) => {
          let dateObj = moment(value);
          let dateStr = dateObj.isValid() ? dateObj.format(DATE_TIME_DISPLAY_FORMAT) : '';
          return (
            <>
              <div style={{ inlineSize: "100px", overflowWrap: "break-word" }}>
                <Typography component={"span"} noWrap={false} variant="">
                  {dateStr}
                </Typography>
              </div>
            </>
          );
        },

      }
    },
    {
      name: "updated_date",
      label: "Modified Date",

      options: {
        customBodyRender: (value, tableMeta) => {
          let dateObj = moment(value);
          let dateStr = dateObj.isValid() ? dateObj.format(DATE_TIME_DISPLAY_FORMAT) : '';
          return (
            <>
              <div style={{ inlineSize: "100px", overflowWrap: "break-word" }}>
                <Typography component={"span"} noWrap={false} variant="">
                  {dateStr}
                </Typography>
              </div>
            </>
          );
        },

      }
    },
    {
      name: "IsActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value, tableMeta) => {
          console.log(tableMeta.tableData[tableMeta.rowIndex].Id)
          let id = masterData[tableMeta.rowIndex].Id;
          console.log(id, 'id');
          return (
            //placement="right"
            <Tooltip title="edit">
              <p className="ml-3">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick('calendarEvent-master/edit', id);
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </p>
            </Tooltip>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    customSearchRender: debounceSearchRender(500),
    responsive: "standard",
    onChangeRowsPerPage: () => {
      // num
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  async function handleClick(url, Id) {
    storeInEncLocalStorage("tokennumber", await Encrypt(JSON.stringify(Id)));
    history.push({
      pathname: `${url}`,
    });
  }

  return (
    <>
      <Main active={"calendarEvent_master"} removeContainer={true} >
        <Loadspinner filename="CalendarEventMaster.js" isLoading={loading} isMiddle="false" />
        <div className="eventGallery">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-8">
                <h4 style={{ paddingLeft: "15px" }}>Master</h4>
              </div>
              <div className="col-md-4 mainBtn-right d-flex justify-content-end" style={{ padding: '0% 3% 0% 0%' }}>
                <div
                  className="float-right col-sm-offset-2"
                >
                  <button
                    className="btn btn-export"
                    style={{ marginLeft: 5 }}
                    onClick={() => exportToExcelFunction()}
                  >
                    Export To Excel
                  </button>
                  <button
                    className="btn btn-danger"
                    style={{
                      marginLeft: 5,
                    }}
                    onClick={() => handleClick("calendarEvent-master/edit", 0)}
                  >
                    + Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix"></div>
        <div className="clearfix"></div>
        <div
          className="d-flex align-items-center justify-space-between"
          style={{
            background: "#e61636",
            padding: "10px 20px 10px 10px",
            color: "white"
          }}
        >
          <div className="col-lg-8">Calendar Event</div>
          <div className="d-flex w-100 justify-content-end align-items-center mr-xl-3 mr-md-3">
            <div className="w-100 col-lg-12 col-sm-5 col-xs-10 searchInput">
              <InputForm
                value={searchText}
                placeholder={"Search"}
                isDisabled={false}
                textArea={false}
                onChange={(e) => {
                  if (e.target.value) {
                    setSearchText(e.target.value);
                  } else {
                    setSearchText("");
                  }
                }}
              />
              <i
                style={{ marginRight: "-10px", marginTop: "-3px" }}
                className="fas fa-search"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>

        <div>
          {masterData && masterData.length >= 0 && (
            <DynamicGrid
              options={options}
              data={masterData}
              columns={gridColumns}
            />
          )}
        </div>
      </Main>
    </>
  );
}

export default CalendarEventMaster;
